import React, { useEffect } from 'react'
// import DriverSec1 from '../../Components/DriverSec1/page'
import OwnerTable from '../../Components/OwnerTable/page'
// import DriverSec3 from '../../Components/DriverSec3/page'
import Banner2 from '../../Components/Banner/Banner2'

const Drivers = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
    <Banner2 title="Welcome To Owners" backgroundImage="/assets/images/banner/video-banner-1.jpg"/>
    {/* <DriverSec3/> */}
    <OwnerTable />
    </>
  )
}

export default Drivers